
import Vue from 'vue';

interface Props {
  faqsData: Record<string, any>[];
}

interface Methods {
  toggleItem: (index: number) => void;
}

export default Vue.extend<unknown, unknown, Methods, Props>({
  props: {
    faqsData: {
      type: Array,
      required: true,
    },
  },
  methods: {
    toggleItem(index: number) {
      this.$set(this.faqsData[index], 'isOpen', !this.faqsData[index].isOpen);
    },
  },
});
